var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaAbajo24X24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7072 13.9514C11.8757 14.0959 12.1243 14.0959 12.2929 13.9514L18.5119 8.62082C18.8264 8.35125 19.2999 8.38767 19.5695 8.70217C19.839 9.01666 19.8026 9.49014 19.4881 9.7597L13.2691 15.0903C12.5388 15.7163 11.4612 15.7163 10.731 15.0903L4.51192 9.7597C4.19743 9.49014 4.161 9.01666 4.43057 8.70217C4.70014 8.38767 5.17361 8.35125 5.48811 8.62082L11.7072 13.9514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaAbajo24X24);
export default __webpack_public_path__ + "static/media/FLECHA_ABAJO_24X24.a75572a3cafe0217a085ad36372f8db8.svg";
export { ForwardRef as ReactComponent };